export default "__VITE_ASSET__61E3IRoj__"